import React, { useEffect, useState } from 'react'
import { API_BASE_URL } from '../config/api'
import axios from 'axios'
import { Message } from 'primereact/message'

interface DatabaseStatusProps {
  className?: string
}

const DatabaseStatus: React.FC<DatabaseStatusProps> = ({ className }) => {
  const [isChecking, setIsChecking] = useState(true)
  const [hasError, setHasError] = useState(false)

  useEffect(() => {
    const checkDatabaseStatus = async () => {
      try {
        await axios.get(`${API_BASE_URL}/health`, { timeout: 5000 })
        setHasError(false)
      } catch (error: any) {
        console.log('Database status check failed:', error.response?.data)
        if (error.response?.data?.error?.code === 'DATABASE_CONNECTION_ERROR') {
          setHasError(true)
        }
      } finally {
        setIsChecking(false)
      }
    }

    checkDatabaseStatus()
  }, [])

  if (isChecking) {
    return null
  }

  if (!hasError) {
    return null
  }

  return (
    <Message
      severity="warn"
      className={`w-full ${className}`}
      content={
        <div>
          <div className="font-semibold mb-2">⚠️ Database Connection Issue Detected</div>
          <div className="text-sm">
            The PostgreSQL database appears to be offline.
            <br />
            Please start it by running:
            <br />
            <code className="bg-gray-100 px-1 rounded text-xs">./start-dev.sh</code>
            <br />
            <span className="text-xs text-gray-600">or manually: cd database && docker-compose -f docker-compose.dev.yml up -d</span>
          </div>
        </div>
      }
    />
  )
}

export default DatabaseStatus